import React, { Component } from "react"
import Header from "../Start/modules/SmallHeader"
import Footer from "../Start/modules/Footer"
import Content from "./modules/Content"
import Navigation from "../Start/modules/Navigation"

export default class extends Component {
    render() {
        return <>
            <Navigation />
            <Header title="Datenschutzerklärung zur FS2-App" subTitle="Stand Mai 2025" image="/img/privacy.jpg" />
            <Content>
                <div className="content">
                    <h1>Datenschutzerklärung für die scanmetrix Field Service 2 App</h1>

                    <h2>1. Einleitung</h2>
                    <p>
                        Wir, die <strong>scanmetrix.fm GmbH</strong>, nehmen den Schutz Ihrer personenbezogenen Daten sehr ernst.
                        Mit der nachfolgenden Datenschutzerklärung informieren wir Sie gemäß Art. 13 und 14 DSGVO über Art, Umfang und Zweck
                        der Verarbeitung personenbezogener Daten im Rahmen der Nutzung unserer App 'scanmetrix Field Service 2'.
                    </p>

                    <h2>2. Verantwortlicher</h2>
                    <p>
                        <strong>scanmetrix.fm GmbH</strong><br />
                        An der Pönt 62<br />
                        40885 Ratingen<br />
                        Deutschland<br />
                        E-Mail: <a href="mailto:info@scanmetrix.fm">info@scanmetrix.fm</a><br />
                        Telefon: +49 (0)2102 56 56 930
                    </p>

                    <h2>3. Allgemeine Hinweise zur Datenverarbeitung</h2>
                    <h3>3.1 Rechtsgrundlagen</h3>
                    <p>Wir verarbeiten Ihre Daten auf Basis folgender Rechtsgrundlagen:</p>
                    <ul>
                        <li>Art. 6 Abs. 1 lit. a DSGVO – Einwilligung</li>
                        <li>Art. 6 Abs. 1 lit. b DSGVO – Vertragserfüllung</li>
                        <li>Art. 6 Abs. 1 lit. c DSGVO – rechtliche Verpflichtung</li>
                        <li>Art. 6 Abs. 1 lit. f DSGVO – berechtigtes Interesse</li>
                    </ul>

                    <h3>3.2 Betroffene Personen</h3>
                    <p>Betroffen sind insbesondere Monteure (App-Nutzer) und ggf. Kunden bzw. Bewohner der betreuten Immobilien.</p>

                    <h3>3.3 Verarbeitete Datenkategorien</h3>
                    <ul>
                        <li>Standortdaten (GPS)</li>
                        <li>Kamerazugriffe und Bilder</li>
                        <li>Geräte- und Nutzungsdaten</li>
                        <li>Logdaten und anonyme Nutzungsstatistiken</li>
                        <li>Offline gespeicherte Auftragsdaten</li>
                    </ul>

                    <h2>4. Einzelne Funktionen und Zwecke</h2>
                    <h3>4.1 GPS-Tracking</h3>
                    <p>
                        Zur Dokumentation von Einsatzorten und zur Navigation erhebt die App bei aktiver Nutzung Standortdaten. Die Übermittlung erfolgt verschlüsselt an das ERP-System. Die Verarbeitung erfolgt auf Basis von Art. 6 Abs. 1 lit. f DSGVO bzw. Art. 6 Abs. 1 lit. a DSGVO bei Einwilligung.
                    </p>

                    <h3>4.2 Zugriff auf Kamera</h3>
                    <p>
                        Zur Fotodokumentation von Anlagenzuständen wird auf die Gerätekamera zugegriffen. Bilder werden lokal gespeichert und mit dem ERP-System synchronisiert. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
                    </p>

                    <h3>4.3 Lokale Dateispeicherung</h3>
                    <p>
                        Zur Offline-Nutzung speichert die App Daten lokal, die bei bestehender Verbindung synchronisiert und anschließend automatisch gelöscht werden. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO.
                    </p>

                    <h3>4.4 Anonymes Usage Tracking</h3>
                    <p>
                        Zur Verbesserung der App-Qualität erheben wir anonyme Nutzungsdaten (z. B. Geräteinformationen, Absturzberichte). Die Auswertung erfolgt nicht nutzerbezogen. Grundlage ist Art. 6 Abs. 1 lit. f DSGVO.
                    </p>

                    <h2>5. Empfänger der Daten</h2>
                    <p>
                        Daten können weitergegeben werden an:
                    </p>
                    <ul>
                        <li>Interne Fachabteilungen</li>
                        <li>Hosting-/Cloud-Dienstleister innerhalb der EU</li>
                        <li>Vertraglich gebundene Auftragsverarbeiter gemäß Art. 28 DSGVO</li>
                        <li>Behörden bei gesetzlicher Verpflichtung</li>
                    </ul>

                    <h2>6. Speicherdauer</h2>
                    <ul>
                        <li>Standortdaten: max. 90 Tage</li>
                        <li>Fotos: max. 30 Tage (lokal), nach Übertragung gelöscht</li>
                        <li>Offline-Daten: nach Synchronisation gelöscht</li>
                        <li>Anonyme Daten: max. 180 Tage</li>
                    </ul>

                    <h2>7. Datensicherheit</h2>
                    <p>
                        Wir schützen Ihre Daten durch technische und organisatorische Maßnahmen (z. B. Verschlüsselung, Zugriffskontrollen, Sicherheitsupdates) gemäß Art. 32 DSGVO.
                    </p>

                    <h2>8. Ihre Rechte</h2>
                    <ul>
                        <li>Auskunft (Art. 15 DSGVO)</li>
                        <li>Berichtigung (Art. 16 DSGVO)</li>
                        <li>Löschung (Art. 17 DSGVO)</li>
                        <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                        <li>Widerspruch (Art. 21 DSGVO)</li>
                        <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                        <li>Widerruf einer Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
                        <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
                    </ul>
                    <p>
                        Zuständige Behörde z. B.:<br />
                        <strong>Landesbeauftragte für Datenschutz NRW</strong><br />
                        Kavalleriestraße 2–4, 40213 Düsseldorf<br />
                        <a href="https://www.ldi.nrw.de" target="_blank" rel="noopener">www.ldi.nrw.de</a>
                    </p>

                    <h2>9. Bereitstellungspflicht</h2>
                    <p>
                        Die Bereitstellung der Daten ist erforderlich, um die Funktionen der App nutzen zu können. Bei Verweigerung können einzelne Funktionen eingeschränkt oder unbrauchbar sein.
                    </p>

                    <h2>10. Änderungen</h2>
                    <p>
                        Diese Erklärung wird regelmäßig angepasst. Die jeweils aktuelle Version ist jederzeit in der App abrufbar.
                    </p>

                    <p><em>Stand: 04. Mai 2025</em></p>
                </div>
            </Content>
            <Footer />
        </>
    }
}
